/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { Check, ChevronsUpDown, XIcon } from "lucide-react";

import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

import { useEffect, useState } from "react";
import { GenericType } from "@/types";
export const SelectWithSearch = ({
  placeholder,
  value,
  onChange,
  defaultValue,
  options,
  bindValue,
  bindLabel,
  className,
  onBlur,
  clearable,
}: GenericType) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      if (defaultValue) {
        onChange(defaultValue);
      }
    }, 100);
  }, [defaultValue]);

  const displayLabel = options?.find(
    (item: GenericType) => item?.[bindValue] === value
  )?.[bindLabel];

  const isChecked = (option1: any, options2: any) => {
    const temp_1 =
      typeof option1 === "string" ? option1.toLowerCase() : option1;
    const temp_2 =
      typeof options2 === "string" ? options2.toLowerCase() : option1;
    return temp_1 === temp_2;
  };

  return (
    <Popover open={open} onOpenChange={setOpen} modal={true}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className={cn("w-full justify-between capitalize", className)}
        >
          <span className="truncate">
            {displayLabel || value || (
              <span className="opacity-65">{placeholder}</span>
            )}
          </span>
          <span className="flex items-center">
            {clearable && value ? (
              <Button
                type="button"
                variant="ghost"
                className=""
                size="icon"
                onClick={() => {
                  onChange("");
                  setOpen(false);
                }}
              >
                <XIcon />
              </Button>
            ) : null}
            <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
          </span>
        </Button>
      </PopoverTrigger>

      <PopoverContent
        className="w-full p-0 z-[999999]"
        align="start"
        onBlur={onBlur}
      >
        <Command className="w-full">
          <CommandInput placeholder="Search..." className="h-9" />
          <CommandList>
            <CommandEmpty>No Item found.</CommandEmpty>
            <CommandGroup>
              {options?.map((option: GenericType) => (
                <CommandItem
                  key={option?.[bindValue]}
                  value={option?.[bindLabel]}
                  onSelect={() => {
                    onChange(option?.[bindValue]);
                    setOpen(false);
                  }}
                >
                  {option?.[bindLabel]}
                  <Check
                    className={cn(
                      "ml-auto",
                      isChecked(value, option?.[bindValue])
                        ? "opacity-100"
                        : "opacity-0"
                    )}
                  />
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
